import React from 'react'
import type { NavLinkProps } from 'react-router-dom'
import { BusyButton } from '@ztechapps/webui.button'
import { useTrackEvent } from '@ztechapps/webui.telemetry'
import { ShowIf } from '@ztechapps/webui.util'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { routesDef } from '../../../config/routes'
import { useUser } from '../../../hooks/useUser'
import { ProductCategoryNavLink } from '../../../components/Header/menu/ProductCategoryNavLink'
import { useConversationWidgetContext } from '../../../components/ConversationWidget'
import styles from './NavigationBar.module.scss'

const ReactiveNavigationLink = (props: NavLinkProps & React.RefAttributes<HTMLAnchorElement>) => {
  return (
    <NavLink
      to={props.to}
      className={({ isActive, isPending }) => `nav-link ${isPending ? 'pending ' : isActive ? 'active' : ''}`}
    >
      {props.children}
    </NavLink>
  )
}

export default function NavigationBar() {
  const { loggedIn } = useUser()
  const { openConversationWidget } = useConversationWidgetContext()
  const trackEvent = useTrackEvent()
  const [clicked, setClicked] = React.useState(false)

  const onRequestQuoteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setClicked(true)
    trackEvent('request_quote.click', { location: 'desktop_nav' })
    openConversationWidget()
  }

  return (
    <Navbar expand="lg" className="bg-primary-subtle">
      <Container>
        <Nav className="me-auto">
          <ProductCategoryNavLink />
          <ReactiveNavigationLink to={routesDef.ProductListPage.altPath()}>All Products</ReactiveNavigationLink>
          <ShowIf condition={loggedIn}>
            <ReactiveNavigationLink className="nav-link" to={routesDef.AccountOrders.altPath()}>
              My Orders
            </ReactiveNavigationLink>
          </ShowIf>
          <ReactiveNavigationLink className="nav-link" to={routesDef.UseAndCareListPage.altPath()}>
            Use and care
          </ReactiveNavigationLink>
        </Nav>
        <Nav className="ms-auto">
          <BusyButton
            variant="success"
            icon="file-pen"
            text="Request a Quote"
            className={clicked ? styles.requestQuoteCtaClicked : styles.requestQuoteCta}
            onClick={onRequestQuoteClick}
            title="Request a Quote"
          />
        </Nav>
      </Container>
    </Navbar>
  )
}
